module.exports = __webpack_public_path__ + "static/media/vtex15.0a20c8dd.png";